module.exports = __webpack_public_path__ + "media/images/home/flow_p_index_2-b0523fce01836672b4c318d363f42e4b.svg";